import { render, staticRenderFns } from "./OrganizationsListItemExpanded.vue?vue&type=template&id=1dbcd2f1&"
import script from "./OrganizationsListItemExpanded.vue?vue&type=script&lang=js&"
export * from "./OrganizationsListItemExpanded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports